// Key for storing copied format in localStorage
export const COPY_FORMAT_STORAGE_KEY = 'aha-editor-v2-copied-format';

// Marks that can be copied/pasted using ToolCopyFormat/ToolPasteFormat
export const COPYABLE_MARKS = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'textColor',
  'textHighlight',
  'fontFamily',
  'fontSize',
] as const;
